import { extractB3dmFeatureTable } from './feature-table';
import { extractB3dmGlb } from './glb';
import { extractB3dmHeader } from './header';
import { B3dmContent } from './types';

/**
 *  Returns the geometry data loaded from the Cesium b3dm file specified in data
 *  https://github.com/CesiumGS/3d-tiles/tree/main/specification/TileFormats/Batched3DModel
 */
export const loadB3dm = (data: Buffer): B3dmContent => {
  const b3dmHeader = extractB3dmHeader(data);
  const featureTable = extractB3dmFeatureTable(data, b3dmHeader);
  const extractedGlb = extractB3dmGlb(data, b3dmHeader);

  return {
    header: b3dmHeader,
    featureTable,
    glb: extractedGlb,
  };
};
